// extracted by mini-css-extract-plugin
export default {"layout":"BonusWithGamesPopup__layout--2aa","game":"BonusWithGamesPopup__game--qH1","slide":"BonusWithGamesPopup__slide--25U","slider":"BonusWithGamesPopup__slider--J7a"};